import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import { PhoneUtils, CurrencyUtils, OrderViewUtils } from 'PMT/utils';

// -- entities
import Order from 'PMT/entities/order/Order';
import OrderSettings from 'PMT/entities/order/OrderSettings';

// -- views
import SvgIcon from 'PMT/components/SvgIcon';

/**
*
*/
export default class OrdersToMakeList extends Component {

  static propTypes = {
    orders: PropTypes.arrayOf(Order).isRequired,

    orderSettings: PropTypes.objectOf(OrderSettings).isRequired,
    currencyCode: PropTypes.string,

  };


  //
  // renderers
  //
  renderRow(order: Order) {

    return (
      <tr className={`PRIORITY_${order.getPriority(this.props.orderSettings.manufactureDelay)}`}>
        <td
          className="text-left pickup_date_countdown"
          ref="countdown"
        >
          {order.getRemainingTimeLabel()}
        </td>
        <td>
          {!order.isOnBar() &&
            <SvgIcon
              icon={OrderViewUtils.getIconForMode(order.mode)}
              style={styles.icon}
            />}
          {order.isOnBar() &&
            <SvgIcon
              icon={SvgIcon.ORDER_AT_BAR}
              style={styles.icon}
            />}
        </td>
        <td>
          {!_.isNull(order.user) && !_.isNull(order.user.firstName) && !_.isNull(order.user.lastName) &&
            `${order.user.firstName} ${order.user.lastName}`
          }
        </td>
        <td>
          {!_.isNull(order.check) &&
            <span>
              {CurrencyUtils.formatPriceWithCurrency(order.check.total, this.props.currencyCode)}
            </span>}
        </td>
      </tr>
    );
  }

  render() {
    const sortedOnGoingOrders = _.sortBy(this.props.orders, ['desc'],
    (order: Order): number => {
      return order.dueDate.valueOf();
    });

    const rows = sortedOnGoingOrders.map((order: Order) => {
      return this.renderRow(order);
    });

    return (
      <div className="table_container table-responsive">
        <table className="orders_ready table">
          <thead>
            <tr>
              <th className="text-left">
                <i className="fa fa-clock-o" />
              </th>
              <th>{I18n.tr('order.to_make.type')}</th>
              <th>{I18n.tr('order.to_make.name')}</th>
              <th>{I18n.tr('order.to_make.total')}</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }
}

const styles = {
  icon: {
    height: '25px',
    width: 'auto'
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/order/ordersList/components/notifyOrdersToMakeModal/OrdersToMakeList.js